module.exports = __webpack_public_path__ + "static/media/playstore-4b.8966eaa8.png";